import { ButtonBlok } from "../../types";
import useEventTracking from "../../lib/hooks/tracking";

export const useButtonTracking = (blok: ButtonBlok) => {
  const trackEvent = useEventTracking();
  const onClickAnalytic = () => {
    if (blok.analytics) {
      trackEvent(
        blok.analyticsEventName,
        blok.analyticsMetadata ? JSON.parse(blok.analyticsMetadata) : {}
      );
    }
  }
  const onClickHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    onClickAnalytic();
  }
  return {
    onClickHandler,
  }
}
